import RepairIndicators from "./components/repairIndicators";
import useIndicators from "../../hooks/useIndicators";
import VerticalBarChart from "./components/verticalBarChart";
import GroupTable from "./components/table";
import { formatMilisecondsInDaysHoursMinutes } from "../../utils/dateUtils";

import "./styles.scss";
import { SimpleTooltip } from "@rio-cloud/rio-uikit";
import { useMediaQuery } from "@mui/material";

interface IIIndicatorProps {
  setChassisList: (chassisList: string[]) => void;
  persona: "TOWER" | "MANAGER" | "CONSULTANT" | "PARTNERSHIP";
  assetIds?: string[];
}

const Indicators = ({ persona, setChassisList, assetIds }: IIIndicatorProps) => {
  const {
    loading,
    showIndicators,
    setShowIndicators,

    inProgressIndicators,
    inProgressTotals,

    selectedMetric,
    setSelectedMetric,

    inProgress,
    customer,
    model,
    emissionStandard,
    city,
    state,
    customerIndicators,
    modelIndicators,
    emissionStandardIndicators,
    stateIndicators,
    cityIndicators,
    groupIndicators,

    filterCharts,
    filteredOccurrenceIdList,

    getInProgressTotals,
    allOccurrenceTimeSpentList,
  } = useIndicators(persona, setChassisList, assetIds);
  const isResponsiveView = useMediaQuery('(max-width: 1024px)');
  
  return (
    <div>
      <div className="chart">
        <img
          className="w-[22px] h-[22px] cursor-pointer"
          src="/assets/images/chart.svg"
          alt=""
          onClick={() => setShowIndicators(!showIndicators)}
        />
      </div>

      {showIndicators && (
        <>
          <div
            className="bg-calendar-sidebar"
            onClick={() => setShowIndicators(!showIndicators)}
          />
          <div
            className={`${isResponsiveView ? 'w-[95%]' : 'w-[85%]'} w-responsive fixed bg-white right-0 top-0 h-[100%] ${isResponsiveView ? 'p-[10px]' : 'p-[20px]'}`}
            style={{ zIndex: "1000" }}
          >
            <div className={`${isResponsiveView ? 'flex-col' : 'flex'} items-center justify-between border-b pb-[15px] mb-[15px]`}>
              <p className="text-[#2A3740] text-[20px] font-semibold mb-[10px]">
                Indicadores de reparo em andamento
              </p>
              <div className="flex">
                <div>
                  <button
                    className={`btn rounded-tr-none rounded-br-none ${isResponsiveView ? 'w-[100px]' : 'w-[125px]'} ${
                      selectedMetric === "average"
                        ? "btn-primary"
                        : "btn-default"
                    }`}
                    onClick={() => setSelectedMetric("average")}
                  >
                    Média de tempo
                  </button>
                  <button
                    className={`btn rounded-tl-none rounded-bl-none ${isResponsiveView ? 'w-[100px]' : 'w-[125px]'} ${
                      selectedMetric === "quantity"
                        ? "btn-primary"
                        : "btn-default"
                    }`}
                    onClick={() => setSelectedMetric("quantity")}
                  >
                    Quantidade
                  </button>
                </div>
              </div>
            </div>

            {selectedMetric === "average" && (
              <div className="overflow-y-scroll h-[100%] pb-[10%] pr-[1%]">
                <div className={`${isResponsiveView ? 'flex-col ' : 'flex'} pt-[15px] gap-6`}>
                  <div
                    style={{ transform: "rotateX(180deg)" }}
                    className={`${isResponsiveView ? 'w-full mb-6' : 'w-[100%]'} overflow-x-scroll panel panel-default panel-body py-[5px] min-h-[190px]`}
                  >
                    <div className="" style={{ transform: "rotateX(180deg)" }}>
                      <RepairIndicators
                        barChartData={
                          inProgressIndicators
                            .map((item) => {
                              const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                              );
                              const spentTime = (inProgress ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                              return filteredOccurrenceIds?.length || inProgress
                                ? {
                                    name: item.name,
                                    value: spentTime / (inProgress ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                    color:
                                      inProgress && inProgress !== item.name
                                        ? "brand-primary-decent"
                                        : "brand-info",
                                  }
                                : undefined;
                            })
                            .filter(Boolean) as {
                            name: string;
                            value: number;
                            color: string;
                          }[]
                        }
                        formatValue={(value: number) =>
                          formatMilisecondsInDaysHoursMinutes(value * 60 * 1000)
                        }
                        onBarClick={(element) =>
                          filterCharts("inProgress", element.name)
                        }
                      />
                    </div>
                  </div>
                  <div className={`${isResponsiveView ? 'flex flex-wrap justify-center w-full gap-4 mt-6' : 'flex flex-column justify-between gap-6 w-[15%]'}`}>
                    <div className={`border rounded flex flex-column items-center justify-center min-h-[85px] ${isResponsiveView ? 'w-[45%]' : 'w-full'}`}>
                      <div className="w-full flex justify-center">
                        <div
                          className="text-color-info text-[25px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                          style={{ fontSize: "clamp(12px, 2.5vw, 25px)" }}
                        >
                          {loading ? (
                            "-"
                          ) : (
                            <SimpleTooltip
                              placement="top"
                              content={formatMilisecondsInDaysHoursMinutes(getInProgressTotals().averageTime * 60 * 1000)}
                            >
                              <div
                                className="text-color-info text-[25px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                                style={{ fontSize: "clamp(12px, 2.5vw, 25px)" }}
                              >
                                {loading ? "-" : formatMilisecondsInDaysHoursMinutes(getInProgressTotals().averageTime * 60 * 1000)}
                              </div>
                            </SimpleTooltip>
                          )}
                        </div>
                      </div>
                      <div className="w-full flex justify-center">
                        <div
                          className="text-[15px] text-color-darker m-[0]"
                          style={{ fontSize: "clamp(12px, 1.5vw, 15px)" }}
                        >
                          Total em reparo
                        </div>
                      </div>
                    </div>
                    <div className={`border rounded flex flex-column items-center justify-center min-h-[85px] ${isResponsiveView ? 'w-[45%]' : 'w-full'}`}>
                      <div className="w-full flex justify-center">
                        <div
                          className="text-color-info text-[25px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                          style={{ fontSize: "clamp(12px, 2.5vw, 25px)" }}
                        >
                          {loading ? (
                            "-"
                          ) : (
                            <SimpleTooltip
                              placement="top"
                              content={formatMilisecondsInDaysHoursMinutes(
                                (inProgressTotals?.finishedAverageTime ?? 0) *
                                  60 *
                                  1000
                              )}
                            >
                              <div
                                className="text-color-info text-[25px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                                style={{ fontSize: "clamp(12px, 2.5vw, 25px)" }}
                              >
                                {loading
                                  ? "-"
                                  : formatMilisecondsInDaysHoursMinutes(
                                      (inProgressTotals?.finishedAverageTime ??
                                        0) *
                                        60 *
                                        1000
                                    )}
                              </div>
                            </SimpleTooltip>
                          )}
                        </div>
                      </div>
                      <div className="w-full flex justify-center">
                        <div
                          className="text-[15px] text-color-darker m-[0]"
                          style={{ fontSize: "clamp(12px, 1.5vw, 15px)" }}
                        >
                          Total concluído
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex gap-6 vertical-charts">
                  <div className="min-h-[360px] overflow-auto">
                    <div className={`${isResponsiveView ? 'flex-col' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                      <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                        <VerticalBarChart
                          title="Chamados por cliente"
                          data={
                            customerIndicators
                              .map((item) => {
                                const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                  (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                                );
                                const spentTime = (customer ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                                return filteredOccurrenceIds?.length || customer
                                  ? {
                                      label: item.name,
                                      value: spentTime / (customer ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                      color:
                                        customer && customer !== item.name
                                          ? "brand-primary-decent"
                                          : "brand-info",
                                    }
                                  : undefined;
                              })
                              .filter(Boolean)
                              .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                              label: string;
                              value: number;
                              color: string;
                            }[]
                          }
                          onBarClick={(element) =>
                            filterCharts("customer", element.label)
                          }
                          formatValue={(value: number) =>
                            formatMilisecondsInDaysHoursMinutes(
                              value * 60 * 1000
                            )
                          }
                          yAxisWidth={120}
                          marginRight={100}
                        />
                      </div>
                      <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                        <VerticalBarChart
                          title="Chamados por modelo"
                          data={
                            modelIndicators
                              .map((item) => {
                                const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                  (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                                );
                                const spentTime = (model ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                                return (model ? item.occurrenceIds?.length : filteredOccurrenceIds?.length) || model
                                  ? {
                                      label: item.name,
                                      value: spentTime / (model ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                      color:
                                        model && model !== item.name
                                          ? "brand-secondary-decent"
                                          : "brand-secondary",
                                    }
                                  : undefined;
                              })
                              .filter(Boolean)
                              .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                              label: string;
                              value: number;
                              color: string;
                            }[]
                          }
                          yAxisWidth={120}
                          marginRight={100}
                          onBarClick={(element) =>
                            filterCharts("model", element.label)
                          }
                          formatValue={(value: number) =>
                            formatMilisecondsInDaysHoursMinutes(
                              value * 60 * 1000
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className={`${isResponsiveView ? 'flex-col w-full' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                      <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                        <GroupTable data={groupIndicators} filteredOccurrenceIdList={filteredOccurrenceIdList} allOccurrenceTimeSpentList={allOccurrenceTimeSpentList} metric="average" />
                      </div>
                      <div className={`${isResponsiveView ? 'w-full' : 'w-[50%]'} min-h-[360px] overflow-auto`}>
                        <VerticalBarChart
                          title="Chamados por legislação"
                          data={
                            emissionStandardIndicators
                              .map((item) => {
                                const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                  (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                                );
                                const spentTime = (emissionStandard ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                                return (emissionStandard ? item.occurrenceIds?.length : filteredOccurrenceIds?.length) || emissionStandard
                                  ? {
                                      label: item.name,
                                      value: spentTime / (emissionStandard ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                      color:
                                        emissionStandard &&
                                        emissionStandard !== item.name
                                          ? "brand-primary-decent"
                                          : "brand-primary",
                                    }
                                  : undefined;
                              })
                              .filter(Boolean)
                              .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                              label: string;
                              value: number;
                              color: string;
                            }[]
                          }
                          yAxisWidth={120}
                          marginRight={100}
                          onBarClick={(element) =>
                            filterCharts("emissionStandard", element.label)
                          }
                          formatValue={(value: number) =>
                            formatMilisecondsInDaysHoursMinutes(
                              value * 60 * 1000
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className={`${isResponsiveView ? 'flex-col' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                      <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                        <VerticalBarChart
                          title="Chamados por cidade"
                          data={
                            cityIndicators
                              .map((item) => {
                                const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                  (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                                );
                                const spentTime = (city ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                                return (city ? item.occurrenceIds?.length : filteredOccurrenceIds?.length) || city
                                  ? {
                                      label: item.name,
                                      value: spentTime / (city ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                      color:
                                        city && city !== item.name
                                          ? "brand-warning-decent"
                                          : "color-map-marker-geofence",
                                    }
                                  : undefined;
                              })
                              .filter(Boolean)
                              .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                              label: string;
                              value: number;
                              color: string;
                            }[]
                          }
                          yAxisWidth={120}
                          marginRight={100}
                          onBarClick={(element) =>
                            filterCharts("city", element.label)
                          }
                          formatValue={(value: number) =>
                            formatMilisecondsInDaysHoursMinutes(
                              value * 60 * 1000
                            )
                          }
                        />
                      </div>
                      <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                        <VerticalBarChart
                          title="Chamados por estado"
                          data={
                            stateIndicators
                              .map((item) => {
                                const filteredOccurrenceIds = item.occurrenceIds?.filter(
                                  (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                                );
                                const spentTime = (state ? item.occurrenceIds : filteredOccurrenceIds)?.reduce((acc, occurrenceId) => acc + (allOccurrenceTimeSpentList.find((el) => el.occurrenceId === occurrenceId)?.timeSpent || 0), 0) || 0;
                                return (state ? item.occurrenceIds?.length : filteredOccurrenceIds?.length) || state
                                  ? {
                                      label: item.name,
                                      value: spentTime / (state ? item.occurrenceIds?.length : filteredOccurrenceIds?.length || 1),
                                      color:
                                        state && state !== item.name
                                          ? "brand-danger-decent"
                                          : "color-warmup-salmon",
                                    }
                                  : undefined;
                              })
                              .filter(Boolean)
                              .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                              label: string;
                              value: number;
                              color: string;
                            }[]
                          }
                          yAxisWidth={120}
                          marginRight={100}
                          onBarClick={(element) =>
                            filterCharts("state", element.label)
                          }
                          formatValue={(value: number) =>
                            formatMilisecondsInDaysHoursMinutes(
                              value * 60 * 1000
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {selectedMetric === "quantity" && (
              <div className="overflow-y-scroll h-[100%] pb-[10%] pr-[1%]">
                <div className={`flex pt-[15px] gap-6 ${isResponsiveView ? 'flex-col' : 'flex-row'}`}>
                  <div
                    style={{ transform: "rotateX(180deg)" }}
                     className={`${isResponsiveView ? 'w-full mb-6' : 'w-[100%]'} overflow-x-scroll panel panel-default panel-body py-[5px] min-h-[190px]`}
                  >
                    <div className="" style={{ transform: "rotateX(180deg)" }}>
                      <RepairIndicators
                        barChartData={
                          inProgressIndicators
                            .map((el) => {
                              const filteredCount = el.occurrenceIds.filter(
                                (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                              )?.length;
                              return (filteredCount || inProgress) && el.qtd > 0
                                ? {
                                    name: el.name,
                                    value: filteredCount || el.qtd,
                                    color:
                                      inProgress && inProgress !== el.name
                                        ? "brand-primary-decent"
                                        : "brand-info",
                                  }
                                : undefined;
                            })
                            .filter(Boolean) as {
                            name: string;
                            value: number;
                            color: string;
                          }[]
                        }
                        onBarClick={(element) =>
                          filterCharts("inProgress", element.name)
                        }
                      />
                    </div>
                  </div>
                  <div className={`${isResponsiveView ? 'flex flex-wrap justify-center w-full gap-4' : 'flex flex-column justify-between gap-6 w-[15%]'}`}>
                    <div className={`border rounded flex flex-column items-center justify-center min-h-[85px] ${isResponsiveView ? 'w-[45%]' : 'w-full'}`}>
                      <p
                        className="text-color-info text-[30px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                        style={{ fontSize: "clamp(12px, 3vw, 30px)" }}
                      >
                        {loading ? "-" : getInProgressTotals().totals}
                      </p>
                      <p className="text-[15px] text-color-darker m-[0]">
                        Total em reparo
                      </p>
                    </div>
                    <div className={`border rounded flex flex-column items-center justify-center min-h-[85px] ${isResponsiveView ? 'w-[45%]' : 'w-full'}`}>
                      <p
                        className="text-color-info text-[30px] m-[0] p-[5px] whitespace-nowrap overflow-hidden"
                        style={{ fontSize: "clamp(12px, 3vw, 30px)" }}
                      >
                        {loading ? "-" : inProgressTotals?.finishedQtd}
                      </p>
                      <p className="text-[15px] text-color-darker m-[0]">
                        Total concluído
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${isResponsiveView ? 'flex-col' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                  <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                    <VerticalBarChart
                      title="Chamados por cliente"
                      data={
                        customerIndicators
                          .map((item) => {
                            const filteredCount = item.occurrenceIds?.filter(
                              (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                            )?.length;
                            return filteredCount || customer
                              ? {
                                  label: item.name,
                                  value: filteredCount || item.qtd,
                                  color:
                                    customer && customer !== item.name
                                      ? "brand-primary-decent"
                                      : "brand-info",
                                }
                              : undefined;
                          })
                          .filter(Boolean)
                          .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                          label: string;
                          value: number;
                          color: string;
                        }[]
                      }
                      onBarClick={(element) =>
                        filterCharts("customer", element.label)
                      }
                      yAxisWidth={120}
                      marginRight={100}
                    />
                  </div>
                  <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                    <VerticalBarChart
                      title="Chamados por modelo"
                      data={
                        modelIndicators
                          .map((item) => {
                            const filteredCount = item.occurrenceIds?.filter(
                              (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                            )?.length;
                            return filteredCount || model
                              ? {
                                  label: item.name,
                                  value: filteredCount || item.qtd,
                                  color:
                                    model && model !== item.name
                                      ? "brand-secondary-decent"
                                      : "brand-secondary",
                                }
                              : undefined;
                          })
                          .filter(Boolean)
                          .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                          label: string;
                          value: number;
                          color: string;
                        }[]
                      }
                      yAxisWidth={120}
                      marginRight={100}
                      onBarClick={(element) =>
                        filterCharts("model", element.label)
                      }
                    />
                  </div>
                </div>

                <div className={`${isResponsiveView ? 'flex-col w-full' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                  <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                    <GroupTable data={groupIndicators} filteredOccurrenceIdList={filteredOccurrenceIdList} allOccurrenceTimeSpentList={allOccurrenceTimeSpentList} metric="quantity" />
                  </div>
                  <div className={`${isResponsiveView ? 'w-full' : 'w-[50%]'} min-h-[360px] overflow-auto`}>
                    <VerticalBarChart
                      title="Chamados por legislação"
                      data={
                        emissionStandardIndicators
                          .map((item) => {
                            const filteredCount = item.occurrenceIds?.filter(
                              (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                            )?.length;
                            return filteredCount || emissionStandard
                              ? {
                                  label: item.name,
                                  value: filteredCount || item.qtd,
                                  color:
                                    emissionStandard &&
                                    emissionStandard !== item.name
                                      ? "brand-primary-decent"
                                      : "brand-primary",
                                }
                              : undefined;
                          })
                          .filter(Boolean)
                          .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                          label: string;
                          value: number;
                          color: string;
                        }[]
                      }
                      yAxisWidth={120}
                      marginRight={100}
                      onBarClick={(element) =>
                        filterCharts("emissionStandard", element.label)
                      }
                    />
                  </div>
                </div>

                <div className={`${isResponsiveView ? 'flex-col' : 'flex'} pt-[25px] gap-6 vertical-charts`}>
                  <div className={`${isResponsiveView ? 'w-full mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                    <VerticalBarChart
                      title="Chamados por cidade"
                      data={
                        cityIndicators
                          .map((item) => {
                            const filteredCount = item.occurrenceIds?.filter(
                              (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                            )?.length;
                            return filteredCount || city
                              ? {
                                  label: item.name,
                                  value: filteredCount || item.qtd,
                                  color:
                                    city && city !== item.name
                                      ? "brand-warning-decent"
                                      : "color-map-marker-geofence",
                                }
                              : undefined;
                          })
                          .filter(Boolean)
                          .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                          label: string;
                          value: number;
                          color: string;
                        }[]
                      }
                      yAxisWidth={120}
                      marginRight={100}
                      onBarClick={(element) =>
                        filterCharts("city", element.label)
                      }
                    />
                  </div>
                  <div className={`${isResponsiveView ? 'w-auto mb-6' : 'w-[50%]'} h-[360px] overflow-auto`}>
                    <VerticalBarChart
                      title="Chamados por estado"
                      data={
                        stateIndicators
                          .map((item) => {
                            const filteredCount = item.occurrenceIds?.filter(
                              (occurrenceId) => filteredOccurrenceIdList.includes(occurrenceId)
                            )?.length;
                            return filteredCount || state
                              ? {
                                  label: item.name,
                                  value: filteredCount || item.qtd,
                                  color:
                                    state && state !== item.name
                                      ? "brand-danger-decent"
                                      : "color-warmup-salmon",
                                }
                              : undefined;
                          })
                          .filter(Boolean)
                          .sort((a, b) => (b?.value ?? 0) - (a?.value ?? 0)) as {
                          label: string;
                          value: number;
                          color: string;
                        }[]
                      }
                      yAxisWidth={120}
                      marginRight={100}
                      onBarClick={(element) =>
                        filterCharts("state", element.label)
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Indicators;
